/**
 * Shared non-color layout tokens used frequently across the new shell.
 * Pair with appThemeColors + appThemeFonts.
 */
export const appThemeRadius = {
  sm: "7px",
  md: "8px",
  lg: "14px",
  pill: "9999px",
  indicator: "0px 3px 3px 0px",
  subItem: "0 7px 7px 0",
};

export const appThemeShadow = {
  menu: "0 20px 50px rgba(16,42,58,.22)",
  card: "0 1px 2px rgba(16,42,58,.04)",
};

export const appThemeTransition = {
  navWidth: "width 0.17s cubic-bezier(.2, 0, .2, 1)",
  iconRotate: "transform 0.17s ease",
  chevron: "transform 0.15s ease",
};

export const appThemeSpace = {
  xxs: "2px",
  xs: "4px",
  sm: "6px",
  md: "8px",
  lg: "10px",
  xl: "12px",
  xxl: "14px",
};

export const appThemeSize = {
  headerHeight: 52,
  headerDividerHeight: 22,
  headerLogoHeight: 38,
  iconButton: 34,
  iconButtonSm: 32,
  iconButtonXs: 28,
  railActionHeight: 32,
  menuIcon: 16,
  menuChevron: 14,
  navIcon: 19,
  collapseIcon: 18,
  drawerWidth: 264,
  drawerCollapsedWidth: 64,
  navItemHeight: "40px",
  menuWidthSm: 240,
  menuWidthMd: 260,
  menuWidthLg: 300,
  tableRowHeight: 52,
  tableHeaderMinHeight: 38,
  tableFilterControlHeight: 32,
  actionButtonHeight: 36,
  cardPad: 20,
};

export const appThemeZIndex = {
  header: 1400,
  /** Above TopHeader (1400); MUI default modal is 1300. */
  modal: 1500,
};

export const appThemeTokensCssVars = {
  "--app-radius-sm": appThemeRadius.sm,
  "--app-radius-md": appThemeRadius.md,
  "--app-radius-lg": appThemeRadius.lg,
  "--app-radius-pill": appThemeRadius.pill,

  "--app-shadow-menu": appThemeShadow.menu,
  "--app-shadow-card": appThemeShadow.card,

  "--app-space-sm": appThemeSpace.sm,
  "--app-space-md": appThemeSpace.md,
  "--app-space-lg": appThemeSpace.lg,
  "--app-space-xl": appThemeSpace.xl,

  "--app-header-h": `${appThemeSize.headerHeight}px`,
  "--app-drawer-w": `${appThemeSize.drawerWidth}px`,
  "--app-drawer-collapsed-w": `${appThemeSize.drawerCollapsedWidth}px`,
  "--app-nav-h": appThemeSize.navItemHeight,
};
